import React from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Alert, Button } from 'components/ui'

const CHUNK_RELOAD_KEY = 'routeChunkReloadAt'
const CHUNK_RELOAD_INTERVAL = 30000

// Deploy sırasında henüz yüklenmemiş/silinmiş lazy chunk istenirse webpack ChunkLoadError fırlatır
const isChunkLoadError = (error) => error?.name === 'ChunkLoadError'
	|| /Loading (CSS )?chunk [\w-]+ failed/i.test(error?.message || '')

// Aynı oturumda 30 sn içinde ikinci kez yenilemeyerek döngüye girmeyi engeller
const reloadOnceForChunkError = () => {
	try {
		const lastReload = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0)
		if (Date.now() - lastReload < CHUNK_RELOAD_INTERVAL) {
			return false
		}
		sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()))
	} catch (e) {
		return false
	}
	window.location.reload()
	return true
}

const ErrorFallback = ({ fullPage }) => {
	const { t } = useTranslation()

	return (
		<div className={fullPage ? 'flex items-center justify-center h-[100vh] p-4' : 'p-4'}>
			<Alert showIcon type="danger" title={t('error')}>
				<p>{t('pageCrashed')}</p>
				<Button className="mt-3" size="sm" variant="solid" onClick={() => window.location.reload()}>
					{t('reloadPage')}
				</Button>
			</Alert>
		</div>
	)
}

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props)
		this.state = { error: null }
	}

	static getDerivedStateFromError(error) {
		return { error }
	}

	componentDidCatch(error, info) {
		console.error('Sayfa render hatası:', error, info?.componentStack)
		if (isChunkLoadError(error)) {
			reloadOnceForChunkError()
		}
	}

	componentDidUpdate(prevProps) {
		// Başka sayfaya geçince hata ekranı sıfırlanır, menü kullanılabilir kalır
		if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
			this.setState({ error: null })
		}
	}

	render() {
		if (this.state.error) {
			return <ErrorFallback fullPage={this.props.fullPage} />
		}
		return this.props.children
	}
}

const RouteErrorBoundary = ({ children, fullPage = false }) => {
	const location = useLocation()

	return (
		<ErrorBoundary resetKey={location.pathname} fullPage={fullPage}>
			{children}
		</ErrorBoundary>
	)
}

export default RouteErrorBoundary
